var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingFatca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGRoot",
    height: 300,
    viewBox: "0 0 512 512",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3844",
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3817",
    d: "m37.322266 435.556c-20.485808 0-37.322266 16.83465-37.322266 37.32062v1.8008c0 20.48598 16.836458 37.32258 37.322266 37.32258h437.355464c20.48581 0 37.32227-16.8366 37.32227-37.32258v-1.8008c0-20.48597-16.83646-37.32062-37.32227-37.32062z",
    strokeWidth: 22,
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3820",
    d: "m38.228516 217.075a11 11.000111 0 0 0 -11 11.00011v163.32978a11 11.000111 0 0 0 11 11.00011 11 11.000111 0 0 0 11-11.00011v-163.32978a11 11.000111 0 0 0 -11-11.00011z",
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3823",
    d: "m147.11426 217.075a11 11.000111 0 0 0 -11 11.00011v163.32978a11 11.000111 0 0 0 11 11.00011 11 11.000111 0 0 0 11-11.00011v-163.32978a11 11.000111 0 0 0 -11-11.00011z",
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3826",
    d: "m256 217.075a11 11.000111 0 0 0 -11 11.00011v163.32978a11 11.000111 0 0 0 11 11.00011 11 11.000111 0 0 0 11-11.00011v-163.32978a11 11.000111 0 0 0 -11-11.00011z",
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3829",
    d: "m364.88574 217.075a11 11.000111 0 0 0 -11 11.00011v163.32978a11 11.000111 0 0 0 11 11.00011 11 11.000111 0 0 0 11-11.00011v-163.32978a11 11.000111 0 0 0 -11-11.00011z",
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3832",
    d: "m473.77148 217.075a11 11.000111 0 0 0 -11 11.00011v163.32978a11 11.000111 0 0 0 11 11.00011 11 11.000111 0 0 0 11-11.00011v-163.32978a11 11.000111 0 0 0 -11-11.00011z",
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3835",
    d: "m255.99415 0c-3.93244 0-7.86453.62941551-11.64258 1.8886719l-211.009771 70.3320311c-19.874487 6.624481-33.34565126 25.318174-33.34179725 46.267577l.00389999 27.21875c.0038 20.97931 17.24919126 38.22051 38.22851626 38.2207l435.548832.002c20.9791.00013 38.22118-17.24357 38.21875-38.22266l-.004-27.22265c-.00232-20.949361-13.47511-39.639398-33.34951-46.263717l-211.00781-70.3320311c-3.77802-1.25925639-7.71209-1.8886719-11.64453-1.8886719zm.006 53.042969c20.97916 0 38.22266 17.241082 38.22266 38.220703 0 20.979628-17.2435 38.224608-38.22266 38.224608s-38.22266-17.24498-38.22266-38.224608c0-20.979621 17.2435-38.220703 38.22266-38.220703z",
    strokeWidth: 22,
    fill: "#577188",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingFatca);
export default __webpack_public_path__ + "static/media/building-fatca.b885b8f46b20c9a17d8f98d0509127e6.svg";
export { ForwardRef as ReactComponent };